
  <div class="filter-container">
    <form [formGroup]="byRegisteredForm">
      <div formArrayName="registeredUsers">
        <div
          class="sgc"
          *ngFor="let userCtrl of registeredUsers.controls; let i = index"
        >
          <single-choice
            [formControl]="userCtrl"
            (click)="setEditingIndex(i)"
            [completedUrl]="completionUrl"
            [topic]="'users'"
            [editMode]="true"
            [ticketId]="fakeId"
            [icon]="'how_to_reg'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="registeredLabelerByService"
            [choiceObserver]="registeredObserver"
          ></single-choice>
        </div>
      </div>

      <button type="button" class="add-registered-btn" (click)="addUserField()">
        +
      </button>

      <not
        [filter]="byRegisteredFilter"
        (filterChanged)="onFilterChanged($event)"
      ></not>

      <button class="apply-filter-btn" type="submit" (click)="apply()">
        Apply
      </button>
    </form>
  </div>

